import ReactPlayer from "react-player/youtube";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userActivity } from "../../../common/constants";
import Breadcrumb from "../../../components/Breadcrumb";
import {
  markLessonAsWatched,
  markVideoUnplayable,
} from "../../../redux/actions/contentPayer";
import { addUserActivity } from "../../../redux/actions/profileDetails";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";
import { useCallback, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClosedCaptioning, faExpand, faFastBackward, faFastForward, faPause, faPlay, faVolumeMute, faVolumeUp } from "@fortawesome/free-solid-svg-icons";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { useRef } from "react";
import axios from "axios";

const format = (seconds)=>{
  if(seconds === "00:00")
  return "00:00"
  const date = new Date(seconds*1000);

  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = date.getUTCSeconds();

  if(hh){
    if(ss<=9)
    return `${hh}:${mm.toString().padStart(2,"0")}:0${ss}`
    
    return `${hh}:${mm.toString().padStart(2,"0")}:${ss}`
  }
  else{
    if(ss<=9)
    return `${mm.toString().padStart(2,"0")}:0${ss}`
    return `${mm.toString().padStart(2,"0")}:${ss}`
  }
}
let count = 5;
export default function VideoPlayer({
  sideMenuItems,
  lessonId,
  setWatchedLessons,
  videoStartTime,
  videoEndTime,
  videoURL,
  playerRef,
  breadcrumbs,
  videoDuration,
  videoThumbnail
}) {
  const dispatch = useDispatch();
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const navigate = useNavigate();
  const user_token = useSelector((store) => store?.authentication?.user_token);
  const email = useSelector((store) => store?.profileDetails?.email);
  const componentRef = useRef(null);

  function playNext(currentlessonId) {
    const index = sideMenuItems?.findIndex(
      (item) => item.id === currentlessonId
    );
    if (index < sideMenuItems.length - 1) {
      const nextContent = sideMenuItems[index + 1];
      navigate(
        user_token
          ? `../${nextContent.course_slug}/${nextContent.skill_slug}/${nextContent.mskill_slug}/${nextContent.id}`
          : `../${nextContent.course_slug}/${nextContent.skill_slug}/${nextContent.mskill_slug}/${nextContent.id}/new_user`
      );
    }
  }

  const handleProgress = useCallback((state) => {
    if (state.playSeconds >= videoDuration) {
      playerRef.current.seekTo(0);
      playerRef.current.pause();
    }
  }, []);

  function getVideoURL(url, startTime, stopTime) {
    const urlParams = url.split("?").length;

    if (startTime > 0 && stopTime > 0)
      return `${url}${
        urlParams > 1
          ? `&start=${startTime}&end=${stopTime}`
          : `?start=${startTime}&end=${stopTime}`
      }`;
    else if (startTime === 0 && stopTime > 0)
      return `${url}${urlParams > 1 ? `&end=${stopTime}` : `?end=${stopTime}`}`;
    else if (startTime > 0 && stopTime === 0)
      return `${url}${
        urlParams > 1 ? `&start=${startTime}` : `?start=${startTime}`
      }`;
    return url;
  }
  function handleStart(e) {
    Mixpanel.track(Constants.Mixpanel.VIDEO_LESSON_STARTED, {
      distinct_id: email,
    });

    dispatch(
      addUserActivity(user_id, userActivity.LESSON_STARTED, null, false)
    );
  }

  
  


  //onMouseEnter={handleVisibleControl} onMouseLeave={handleHideControl}
  return (
    <div className="w-full  px-2 text-zinc-800 md:w-5/6">
      {breadcrumbs && (
        <div className="p-2">
          <Breadcrumb crumbs={breadcrumbs} />
        </div>
      )}
       <div className="reactour-videoplayer overflow-hidden shadow-lg">
                <ReactPlayer
                    url={getVideoURL(videoURL, videoStartTime, videoEndTime)}
                    config={{
                        file: {
                            attributes: {
                              preload: 'auto',
                              poster : videoThumbnail,
                            },
                        },
                        youtube: {
                            playerVars: { modestbranding: 1, rel: 0 ,cc_load_policy:1 , cc_lang_pref:'en'},
                        },
                    }}
                    width={'100%'}
                    height={window.innerWidth > 768 ? '65vh' : '42vh'}
                    controls={true}
                    playing={true}
                    ref={playerRef}
                    onProgress={(e) => handleProgress(e)}
                    onStart={handleStart}
                    onEnded={() => {
                        user_token ?
                            dispatch(markLessonAsWatched(user_id, lessonId, successObj => {
                                dispatch(addUserActivity(user_id, userActivity.LESSON_WATCHED, "", false))
                                setWatchedLessons(prev => [...prev, successObj])
                                playNext(lessonId)
                            }))
                            :
                            playNext(lessonId)
                    }}
                    onPlay={(e) => {
                        Mixpanel.track(Constants.Mixpanel.VIDEO_PLAYER_PLAY, {
                            distinct_id: email
                        });
                    }}
                    onPause={(e) => {
                        Mixpanel.track(Constants.Mixpanel.VIDEO_PLAYER_PAUSE, {
                            distinct_id: email
                        });
                    }}
                />
            </div>
      
       </div>
  );
}
